import logoMoongy from "../assets/images/logo_MoOngy.svg";
import logoAdentis from "../assets/images/adentis-novo-logo-dark-horizontal.svg";
import logoBee from "../assets/images/Bee/Logotipos/Logotipo_Bee_dark.svg";
import logoAgap2 from "../assets/images/logo_agap2IT.svg";
import logoKCS from "../assets/images/logo_KCSiT.svg";
import logoCodeWin from "../assets/images/logo_CodeWin.svg";
import logoTeamIT from "../assets/images/logo_TeamIT.svg";
import logoRecodme from "../assets/images/logo_Recodme.svg";
import { getCompanyTenant } from "../constants/companies";

export const TENANTS = {
  ADENTIS: "adentis",
  BEE: "bee",
  MOONGY: "moongy",
  AGAP2: "agap2",
  KCS: "kcs",
  CODEWIN: "codewin",
  TEAMIT: "teamit",
  RECODME: "recodme",
};

export const tenantConfig = {
  [TENANTS.ADENTIS]: {
    name: "Adentis",
    logo: logoAdentis,
    favicon: "/adentis.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.BEE]: {
    name: "Bee",
    logo: logoBee,
    favicon: "/favicon_bee.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.MOONGY]: {
    name: "Moongy",
    logo: logoMoongy,
    favicon: "/moOngy_favIocn.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.AGAP2]: {
    name: "Agap2",
    logo: logoAgap2,
    favicon: "/agap2IT_favIcon.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.KCS]: {
    name: "KCS IT",
    logo: logoKCS,
    favicon: "/KCS_Fav Icocn.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.CODEWIN]: {
    name: "CodeWin",
    logo: logoCodeWin,
    favicon: "/CodeWin_favIco.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.TEAMIT]: {
    name: "Team-IT",
    logo: logoTeamIT,
    favicon: "/teamIT_favIcon.ico",
    colors: {
      white: "#fff",
      darkblue: "#0a2038",
      blue: "#005888",
      lightblue: "#77ceff",
      lightestblue: "#e9f7ff",
      grey: "#747985",
      lightgrey: "#f2f2f4",
      red: "#9b2020",
      orange: "#f3983b",
      green: "#0fa958",
    },
  },
  [TENANTS.RECODME]: {
     name: "Recodme",
     logo: logoRecodme,
     favicon: "/Recodme_favIcon.ico",
     colors: {
       white: "#fff",
       darkblue: "#0a2038",
       blue: "#005888",
       lightblue: "#77ceff",
       lightestblue: "#e9f7ff",
       grey: "#747985",
       lightgrey: "#f2f2f4",
       red: "#9b2020",
       orange: "#f3983b",
       green: "#0fa958",
     },
   },
};

export const getDefaultTenant = () => TENANTS.MOONGY;

export const getTenantConfig = (tenantId) => {
  if (!tenantId) return tenantConfig[getDefaultTenant()];

  const tenant = getCompanyTenant(tenantId);
  return tenantConfig[tenant] || tenantConfig[getDefaultTenant()];
};
